<!-- Color -->
<div class="form-group">
    <label>Color</label>
    <nirby-color-picker
        [value]="color"
        (valueChange)="onColorChange($event)"
    ></nirby-color-picker>
</div>
